
function SeedGridController($scope, $rootScope, $mdDialog, $uibModal, $filter, TranslationService, SdGridService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.filterItem = function (item) {
        if (!item) {
            return true;
        }
        return true;
    };

    ctrl.resetPages = function () {
        ctrl.loadedItems = [];
        ctrl.numLoaded = 0;
    };

    ctrl.customFilterCheck = function (item) {
        if (ctrl.prefs.customFilter) {
            return ctrl.prefs.customFilter(item);
        } else {
            return true;
        }
    }; 

    ctrl.customSort = function () {
        if (ctrl.prefs) {
            if (ctrl.prefs.customSort) {
                ctrl.items = $filter('orderBy')(ctrl.items, ctrl.prefs.customSort);
            }
        }
    };

    ctrl.nextPage = function (scroll) {

        ctrl.filters = SdGridService.getFilters(ctrl.prefs.name);
        ctrl.appliedFilters = SdGridService.getAppliedFilters(ctrl.prefs.name);

        ctrl.customSort();
        if (ctrl.busy) {
            ctrl.infiniteScroll = false;
            return;
        }

        if (ctrl.items) {
            var loadNum = ctrl.numLoaded + ctrl.pageSize;
            if (loadNum > ctrl.items.length) {
                loadNum = ctrl.items.length;
            }
            if (ctrl.numLoaded < loadNum) {
                if (scroll == true) {
                    ctrl.infiniteScroll = true;
                }
                ctrl.busy = true;
                for (var i = ctrl.numLoaded; i < loadNum; i++) {
                    var item = ctrl.items[i];
                    var add = false;
                    if (ctrl.filter) {
                        if (ctrl.filter.length > 0) {
                            if (hasFilter(item, ctrl.filter)) {
                                add = true;
                            }
                        } else {
                            add = true;
                        }
                    } else {
                        add = true;
                    }
                    if (add) {
                        ctrl.loadedItems.push(item);
                        ctrl.numLoaded++;
                    }
                }
                ctrl.busy = false;
            }
        }
        ctrl.infiniteScroll = false;
    };

    function hasFilter(item, filter) {
        return Object.keys(item).some(function (k) {
            return filter.includes(item[k]);
        });
    }

    ctrl.loadedItems = [];
    ctrl.numLoaded = 0;
    ctrl.pageSize = 50;
    ctrl.busy = false;

    ctrl.$onChanges = function (changes) {
        if (changes.items) {
            ctrl.nextPage();
        }
    };

    $scope.$on('addItem', function (event, eventArgs) {
        ctrl.editItem(eventArgs, ctrl.columns, null);
    });

    ctrl.openModelEdit = function (cols, item) {
        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Components/grid/sd-grid-edit.html',
            controller: 'EditItemCtrl',
            size: 'md',
            resolve: {
                cols: function () {
                    return cols;
                },
                item: function () {
                    return item;
                }
            }
        });

        modalInstance.result.then(function (newItem) {
            if (newItem) {
                item = newItem;
                ctrl.saveItem(item);
            }
        });
    };

    ctrl.editItemOnList = function (item) {
        if (ctrl.prefs.editOnList) {
            for (var i = 0; i < ctrl.loadedItems.length; i++) {
                ctrl.loadedItems[i].editMode = false;
            }
            item.editMode = true;
            return true;
        }
    };

    ctrl.keyPressed = function (keyEvent, item) {
        if (keyEvent.keyCode === 13 && !keyEvent.shiftKey) {
            item.editMode = false;
            item.showEdit = false;
        }
    };

    ctrl.editItem = function (event, cols, item) {

        if (ctrl.prefs.customEdit && (ctrl.prefs.canAdd || ctrl.prefs.canEdit)) {
            ctrl.prefs.customEdit(item);
            return;
        }

        if (item) {            
            if (!ctrl.prefs.canEdit) {
                return;
            }
        }
        else {
            if (!ctrl.prefs.canAdd) {
                return;
            }
        }
        if (!item) {
            item = {
                IsNew: true,
            };
        }

        ctrl.openModelEdit(cols, item);
    };

    ctrl.saveItem = function (item) {
        if (item) {
            if (ctrl.prefs.saveItem) {
                ctrl.prefs.saveItem(item);
            }
        }
    };

    ctrl.removeConfirmation = function (item) {
        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Components/grid/sd-grid-remove.html',
            controller: 'RemoveConfirmationCtrl',
            size: 'md',
            resolve: {
                item: function () { return item; },
                prefs: function () { return ctrl.prefs;}
            }
        });

        modalInstance.result.then(function () {
        });
    };

    ctrl.sortBy = function (col) {
        var reverse;

        if (col.sortType == 'asc')
            reverse = false;
        else
            reverse = true;

        col.orderReverse = reverse;
        ctrl.prefs.sortByCol = col;

        var colSort;
        if (reverse) {
            colSort = '-' + col.name;
        }
        else {
            colSort = col.name;
        }

        ctrl.items = $filter('orderBy')(ctrl.items, [colSort]);

        ctrl.resetPages();
        ctrl.nextPage();
    };

    ctrl.filters = [];

    ctrl.filterSelected = function (col) {
        var options = col.filterOptions;
        var name = col.name;
        var display = col.display;

        for (var i = ctrl.filters.length - 1; i > -1; i--) {
            if (ctrl.filters[i].name == name) {
                ctrl.filters.splice(i, 1);
            }
        }

        for (var k = 0; k < options.length; k++) {
            options[k].name = name;
            options[k].display = display;
            ctrl.filters.push(options[k]);
        }

        if (ctrl.filters.length > 0) {
            ctrl.loadedItems = ctrl.items;
        } else {
            ctrl.resetPages();
            ctrl.nextPage();
        }
        SdGridService.setFilter(ctrl.prefs.name, ctrl.filters);
        ctrl.handleFilters();
    };

    ctrl.handleFilters = function () {

        ctrl.appliedFilters = [];

        var result = ctrl.filters.reduce(function (r, a) {
            r[a.name] = r[a.name] || [];
            r[a.name].push(a);
            return r;
        }, Object.create(null));

        for (var i in result) {
            ctrl.appliedFilters.push(result[i]);
        }

        SdGridService.setAppliedFilter(ctrl.prefs.name, ctrl.appliedFilters);

    };

    ctrl.deleteFilter = function (filter) {

        var index = ctrl.appliedFilters.indexOf(filter);
        ctrl.appliedFilters.splice(index, 1);

        $rootScope.$broadcast('delete_filter', filter);

    };

    ctrl.filterColumn = function (item) {
        if (ctrl.filters.length > 0) {

            var j = 0;

            for (var i = 0; i < ctrl.filters.length; i++) {

                if (ctrl.filters[i].dataType == 'date') {
                    if (item[ctrl.filters[i].name] != null) {
                        if ((ctrl.filters[i].Value.getUTCMonth() == item[ctrl.filters[i].name].getUTCMonth()) && (ctrl.filters[i].Value.getUTCFullYear() == item[ctrl.filters[i].name].getUTCFullYear()) && (ctrl.filters[i].Value.getUTCDate() == item[ctrl.filters[i].name].getUTCDate())) {
                            j++
                        }
                    }
                } else if (ctrl.filters[i].Value == item[ctrl.filters[i].name]) {
                    j++;
                }

            }

            var result = ctrl.filters.reduce(function (r, a) {
                r[a.name] = r[a.name] || [];
                r[a.name].push(a);
                return r;
            }, Object.create(null));

            var amountOfFilters = 0;

            for (var k in result) {
                amountOfFilters++;
            }

            if (j == amountOfFilters) {
                return true;
            }

            return false;
        } else {
            return true;
        }
    };

    $scope.$watch(function () { return ctrl.filter }, function (newVal, oldVal) {
        if ((ctrl.filter || ctrl.filter == '') && newVal != oldVal) {
            //if (ctrl.filter.length > 0) {
            //    ctrl.loadedItems = ctrl.items;
            //}
            //else {
                ctrl.resetPages();
                ctrl.nextPage();
            //}
        }
    }, true);

}

SeedGridController.$inject = ['$scope', '$rootScope', '$mdDialog', '$uibModal', '$filter', 'TranslationService', 'SdGridService'];

seedWebApp.component('sdGrid', {
    controller: SeedGridController,
    bindings: {
        prefs: '<',
        columns: '<',
        items: '<',
        externalLoading: '<',
        isDialogEdit: '<',
        filter: '=',
        reload: '&',
        overflowSize: '<',
        customFilter: '&'
    },
    templateUrl: '/SPA/Components/grid/sd-grid.html'
});